import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
// import "../public/assets/css/nucleo-icons.css";
// import "../public/assets/css/nucleo-svg.css";
// import ArgonDashboard from "./argon-dashboard";

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
// appInstance.use(ArgonDashboard);
appInstance.mount("#app");
